// // For Create React App, environment variables must start with REACT_APP_
export const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';
export const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN || '';


export const API_ENDPOINTS = {
    POSTS: 'posts',
    PUBLICATIONS: 'publications',
    MAGAZINES: 'magazines',
    CONTACTS: 'contacts',
    SLIDER: 'Slider',
    SLIDES: 'sliders',
    MISSION_VISION: 'misyon-vizyon',
    DIRECTORATES: 'directorates',
    CORPORTATE_GUIDE: 'corporate-guide',
    SYMPOSIUMS: 'main-symposia',
    PRESIDENT: 'president',
    DIRECTORS: 'directors',

    //SYMPOSIUM: 'main-symposium'
    // Add more endpoints as needed
};

export const URL_ENDPOINTS = {
    POSTS: 'basin/haberler',
    PUBLICATIONS: 'basin/yayinlar',
    DIRECTORATES: 'direktorlukler',
    MAGAZINES: 'basin/dergiler',

    CORPORTATE_GUIDE: 'kurumsal/kurumsal-kimlik-rehberi',

    SYMPOSIUMS: 'sempozyumlar',
    // SYMPOSIUM:'main-symposium'

    // Add more endpoints as needed
};

export const POPULATE_PARAMS = {

    HOME_SLIDER: `populate[${API_ENDPOINTS.SLIDER}][populate]=*&sort=publishedAt:desc`,
    // SYMPOSIUM_SLIDER: `?populate[symposium][fields][0]=id&populate[symposium][populate][Slider][populate][files][fields][0]=url`,
    SYMPOSIUM_SLIDER: `populate[symposium][populate][Slider][populate]=files`,

    ONE_WITH_IMAGES: '?populate=*',
    WITH_IMAGES: (page = 1, pageSize = 10) =>
        `?populate=*&pagination[page]=${page}&pagination[pageSize]=${pageSize}`,

    WITH_IMAGES_SORTED_DESC: (page = 1, pageSize = 10) =>
        `?populate=*&pagination[page]=${page}&pagination[pageSize]=${pageSize}&sort[0]=publishedAt:desc`,

    CAROUSEL_WITH_IMAGES_SORTED_DESC: (page = 1, pageSize = 10) =>
        `?fields=id,slug,documentId,title,createdAt,updatedAt,publishedAt` +
        `&pagination[page]=${page}` +
        `&pagination[pageSize]=${pageSize}` +
        `&sort=publishedAt:desc` +
        `&populate[image][fields]=url,formats`,


    DEEP: '?populate=deep',
    NESTED_DIRECTORATES: '?populate[Directorate][populate]=*',
    NESTED_SYMPOSIUMS: '?populate[symposium][populate]=*',
    NESTED_SYMPOSIUMS_PAGINATION: (page = 1, pageSize = 4) =>
        '?populate[symposium][populate]=*' +
        `&pagination[page]=${page}` +
        `&pagination[pageSize]=${pageSize}` +
        '&sort=createdAt:desc',

    NESTED_DIRECTORATES_PAGINATION: (page = 1, pageSize = 10) =>
        '?populate[Directorate][populate]=*' +
        `&pagination[page]=${page}` +
        `&pagination[pageSize]=${pageSize}` +
        '&sort=createdAt:desc',
};
